module.exports = __webpack_public_path__ + "static/debug-commitstrip-3c318d8042ac7a042917354a736d9fe8.jpg";